import React from "react";
import * as styles from "./component.module.less";
import { navigate } from "gatsby";
import t from "../../../lib/translate";

export default function FormContainer({ children }) {
    return (
        <div className={styles.formContainer}>
            {children}
            <button
                className={styles.formCloseButton}
                onClick={() => navigate(-1)}
                aria-label={t`navigation.button.close`}
            />
        </div>
    );
}
